import {usePromotion} from '@/context/Promotion/PromotionContext'

export const useRewardValidations = promotionCondition => {
  const {promotion} = usePromotion()
  const sequenceNumber = promotionCondition?.sequence || 1
  const currentReward = promotionCondition?.rewards?.[0]
  const currentRewardValue = currentReward?.discountValue || currentReward?.points || currentReward?.quantity
  const getConditionValue = (condition, condIndex = 0) => {
    const currentCondition = condition?.conditionGroup?.conditions?.[condIndex]
    const isAmountCondition = currentCondition?.items?.[0]?.uom === 'EA' || currentCondition?.amount != null

    if (isAmountCondition) {
      return currentCondition?.amount
    }

    return currentCondition?.quantity
  }

  // get the highest sequence less than the current one (to account for a deleted middle layer)
  const prevCondition = promotion?.promotionConditions
    ?.filter(cond => cond?.sequence < sequenceNumber)
    .sort((a, b) => b.sequence - a.sequence)[0]

  const hasValueLayerError = () => {
    if (sequenceNumber === 1 || !currentRewardValue) return false
    const prevReward = prevCondition?.rewards?.[0]
    const prevRewardValue = prevReward?.discountValue || prevReward?.points || prevReward?.quantity
    return prevRewardValue >= currentRewardValue
  }

  const hasBuyQuantityLayerError = (condIndex = 0) => {
    const currentQty = getConditionValue(promotionCondition, condIndex)
    if (sequenceNumber === 1 || !currentQty) return false
    const prevQuantity = getConditionValue(prevCondition, condIndex)
    return prevQuantity >= currentQty || (!prevQuantity && currentQty)
  }

  return {
    hasValueLayerError,
    hasBuyQuantityLayerError,
  }
}
